import { QueryClient } from '@tanstack/react-query';
import { handleErrorRedirect } from './errorCodeHandler';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5,
            gcTime: 1000 * 60 * 60,
            retry: 1,
            retryDelay: 1000,
        },
        mutations: {
            onError: (error) => {
                console.error('Mutation error:', error);
                handleErrorRedirect(error);
            },
        },
    },
});